<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>

    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card title="Administration" class="bg-light shadow">
          <b-row>
            <b-col lg="6">
              <b-card title-tag="h6" title="Général" class="bg-light shadow">
                <b-list-group flush>
                  <b-list-group-item :to="{ name: 'negotiators' }"
                    >Gestion des négociateurs</b-list-group-item
                  >
                  <b-list-group-item :to="{ name: 'sellers' }"
                    >Gestion des vendeurs</b-list-group-item
                  >
                  <b-list-group-item :to="{ name: 'localities' }"
                    >Associations Communes - Codes postaux pour la recherche
                    d'adresses</b-list-group-item
                  >
                  <b-list-group-item :to="{ name: 'parameters' }">
                    Paramètres globaux
                  </b-list-group-item>

                  <b-list-group-item :to="{ name: 'archives' }">
                    Archives
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isSuperAdmin"
                    :href="download_backup"
                    target="_blank"
                  >
                    Télécharger le code source de Recuperator v3
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isSuperAdmin"
                    :to="{ name: 'live' }"
                  >
                    Live
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isAdmin"
                    :to="{ name: 'agenda' }"
                  >
                    Anomalies des mises à l'agenda
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isAdmin"
                    :to="{ name: 'routesList' }"
                  >
                    Tournées des négociateurs (trois derniers mois)
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isAdmin"
                    :to="{ name: 'routesList', params: { archive: true } }"
                  >
                    Tournées des négociateurs (archives)
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isAdmin"
                    :to="{ name: 'assignedCreditors' }"
                  >
                    Créanciers assignés
                  </b-list-group-item>
                  <b-list-group-item
                    v-if="$store.getters.isSuperAdmin"
                    :to="{ name: 'migrateWarrants' }"
                  >
                    Migrer tous les mandats d'un créancier vers un autre </b-list-group-item
                  >
                   <b-list-group-item
                    v-if="$store.getters.isSuperAdmin"
                    :to="{ name: 'fusionDebtors' }"
                  >
                    Fusionner deux débiteurs </b-list-group-item
                  >
                  <b-list-group-item
                    v-if="$store.getters.isAdmin"
                    :to="{ name: 'purchaseOrderHistory' }"
                  >
                    Historique des bons de commande
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card title-tag="h6" title="Textes" class="bg-light shadow">
                <b-list-group flush>
                  <b-list-group-item :to="{ name: 'translations' }"
                    >Traductions</b-list-group-item
                  >
                  <b-list-group-item :to="{ name: 'courrierTypes' }"
                    >Gestion des courriers type</b-list-group-item
                  >
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Administration",
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Administration",
          active: true,
        },
      ],
    };
  },
  computed: {
    download_backup() {
      return (
        this.$store.getters.url +
        "/backup/download?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
